import { Link } from "react-router";
import { ContributionPrioritizationTile } from "../../components/dashboard/ContributionPrioritizationTile.js";
import { SectionHeader } from "../../components/design-system/index.js";
import { SuggestedPromptsTile } from "../../components/SuggestedPromptsTile.js";
import { PAGE_PROMPTS } from "../../lib/data/page-prompts.js";
import { useDocumentTitle } from "../../lib/util/use-document-title.js";

/**
 * /fire/contribution-priority — IA review proof-of-pattern (2026-05-09);
 * the rest of the /fire/* sub-pages land in Phase 13.5 following this
 * shape (SectionHeader + back link + tile + SuggestedPromptsTile).
 */
export function FireContributionPriorityPage() {
  useDocumentTitle("FIRE — Where should the next dollar go?");
  return (
    <div className="mx-auto max-w-4xl space-y-6 px-4 py-8 sm:px-6">
      <SectionHeader
        title="Where should the next dollar go?"
        sub="Bogleheads investment-order rungs against your current YTD contributions and IRS limits."
        action={
          <Link
            to="/fire"
            className="rounded-md border border-[var(--color-border-default)] px-3 py-1.5 text-xs font-medium text-[var(--color-muted)] hover:bg-[var(--color-elevated)] hover:text-[var(--color-text)]"
          >
            ← FIRE hub
          </Link>
        }
      />

      <ContributionPrioritizationTile />

      <SuggestedPromptsTile prompts={PAGE_PROMPTS.fireContributionPriority} />
    </div>
  );
}
